module.exports = __webpack_public_path__ + "static/img/7.330c460.jpeg";


//////////////////
// WEBPACK FOOTER
// ./src/images/carousel/7.jpeg
// module id = 45
// module chunks = 1